//*** Api Localhost
//export const ROOT_PATH = "http://localhost:5001/api/"
//export const ROOT_HOME = "http://localhost:8084/loginacudientes/"
//export const ROOT_MODULO_ACUDIENTES = "http://localhost:8085/acudientes/"

//*** Api Servidor
export const ROOT_PATH = "https://siedutunja.gov.co:3001/api/"
export const ROOT_HOME = "https://siedutunja.gov.co/loginacudientes/"
export const ROOT_MODULO_ACUDIENTES = "https://siedutunja.gov.co/acudientes"

export const ID_INSTITUCION = ""

export const ROOT_WEBSITE = "https://siedutunja.gov.co"

export const TITULO_MSG = "SieduTunja"
export const SECRET_KEY = "cataydany3"
export const ALCALDIA = "Alcaldía Mayor de Tunja"
export const SECRETARIA = "Secretaría de Educación Territorial de Tunja"
export const PROYECTO = "SieduTunja | Sistema Único de Información Secretaría de Educación Territorial de Tunja"
